import { useEffect, useState } from 'react';
import api from '../utils/api';

// Founding Member seats, from GET /api/founding/status (the same count the
// admin dashboard and /founding-25 use). The homepage used to hard-code "25"
// forever. One request per page load, shared by every component that asks.
export const FOUNDING_CAP = 25;

let pending = null;

function fetchStatus() {
  if (!pending) {
    pending = api.get('/founding/status', { suppressGlobalError: true })
      .then((res) => res.data || null)
      .catch(() => null);
  }
  return pending;
}

// Test hook: forget the cached request.
export function resetFoundingSpotsCache() {
  pending = null;
}

/**
 * { cap, remaining, isFull, loaded }. `remaining` is null until known (or if
 * the count failed) — callers then fall back to wording without a number.
 */
export default function useFoundingSpots() {
  const [status, setStatus] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let mounted = true;
    fetchStatus().then((data) => {
      if (!mounted) return;
      setStatus(data);
      setLoaded(true);
    });
    return () => { mounted = false; };
  }, []);

  const cap = Number(status?.cap) || FOUNDING_CAP;
  const remaining = Number.isFinite(status?.spotsRemaining) ? status.spotsRemaining : null;
  return { cap, remaining, isFull: status?.isFull === true, loaded };
}
